export const GET_JOURNALS = ' GET_JOURNALS';
export const JOURNALS_FETCH_SUCCESS = 'ACCOUNTGROUP_FETCH_SUCCESS';
export const JOURNALS_FETCH_ERROR = 'ACCOUNTGROUP_FETCH_ERROR';

export const JOURNALS_NUMBER = 'ACCOUNTGROUP_NUMBER';
export const DELETE_JOURNAL = 'DELETE_JOURNAL';
